export default {
  waitList: "WAIT LIST",
  notifications: "NOTIFICATIONS",
  addWaitList: "ADD WAITLIST",
  addGuest: "ADD GUEST",
  guestList: "GUEST LIST",
  rectangle: "RECTANGLE",
  line: "LINE",
  circle: "CIRCLE",
  square: "SQUARE",
  stationLookup: "STATION-LOOKUP",
  allTableLookup: 'ALL-TABLE-LOOUP',
  layoutBuilder: "LAYOUT-BUILDER",
  chair: 'CHAIR',
  table: 'TABLE',
  wall: 'WALL',
  door: 'DOOR',
  window: 'WINDOW',
  sofa: 'SOFA',
  polygon: 'POLYGON',
  arrow: 'ARROW',
  bin: 'BIN',
  table1Seat: 'TABLE-1-SEAT',
  table2Seat: 'TABLE-2-SEAT',
  table4Seat: 'TABLE-4-SEAT',
  table6Seat: 'TABLE-6-SEAT',
  table8Seat: 'TABLE-8-SEAT',
  table10Seat: 'TABLE-10-SEAT',
  tableAll: 'TABLE-ALL',
  staticImages: 'STATIC-IMAGES',
  aquarium: 'AQUARIUM',
  kitchen: 'KITCHEN',
  painting: 'PAINTING',
  restroom: 'RESTROOM',

  tmsBookingActions: 'TMS-BOOKING-ACTIONS',
  tmsCreateBooking: 'TMS-CREATE-BOOKING',
  tmsUpdateBooking: 'TMS-UPDATE-BOOKING',
  tmsTableLookup: 'TMS-TABLE-LOOKUP',
  employeeSelection: 'employeeSelection',
  mergeTableLookup: 'MERGE-TABLE-LOOKUP',
  tmsSensors: 'TMS-SENSORS',
  tmsAbout: 'TMS-ABOUT',
  tmsSms: 'SMS',
  tmsSmsSuccess: 'SMS-SUCCESS',
  tmsSmsError: 'SMS-ERROR',
  helpPopup: 'HELP-POPUP',
  tmsCheckSelectionPopup: 'TMS-CHECK-SELECTION-POPUP',
  showTableMenu: 'SHOW_TABLE_MENU',
};
